import {
    CustomTable,
    TableTypes,
} from "@/components/Home/TradingChartInfoSection/analytics/shared/ui/table";
import styles from "../TechnicalAnalysis.module.scss";

export const MovingAveragesTable = ({
    data,
}: {
    data: {
        period: string;
        simple: number | null;
        exponential: number | null;
        action: string | null;
    }[];
}) => {
    return (
        <div className={styles.tableContainer}>
            <CustomTable
                type={TableTypes.movingAverages}
                data={data?.map((item, index) => ({ ...item, key: index.toString() }))}
            />
            {/* <div className={styles.tableInfo}>
                <ul>
                    {data.map((item, index) => (
                        <li key={index} className={styles.infoLine}>
                            {`${tickerLabel} (${ticker}) ${item.period}-Day 
                            exponential moving average $${Number(item.simple).toFixed(2)}, 
                            while ${tickerLabel} (${ticker}) share price is $${Number(item.exponential).toFixed(2)}, 
                            making it a `}
                            <span style={{ color: "#fff" }}>{`${item.action}.`}</span>
                        </li>
                    ))}
                </ul>
            </div> */}
        </div>
    );
};
